module.exports = __webpack_public_path__ + "static/media/viewmore.23fd7c8d.svg";